import { Component, ChangeDetectionStrategy } from "@angular/core";
import { NgTemplateOutlet } from "@angular/common";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: "rask-takt-chart-legend",
    templateUrl: "./takt-chart-legend.component.html",
    styleUrls: ["./takt-chart-legend.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        NgTemplateOutlet,
        NgbPopover
    ]
})
export class TaktChartLegendComponent {

}
